import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { EditReferent } from './editReferent';
import { ColapsedReferent } from './collapsedReferent';
import { useDispatch, useSelector } from 'react-redux';
import * as R from 'ramda';
import { updateOnBoardingStep } from '../../actions/user-api';
import messageRef from './../../assets/images/svg/076-envelope.svg';
import queryString from 'query-string';

export const ReferentIndex = ({ monReferentRequirements, setMonReferentRequirements, hasFooter }) => {
    const router = useSelector(state => state.router);
    const user = useSelector(state => state.user);
    const history = useHistory();
    const dispatch = useDispatch();
    const [isEditing, setIsEditing] = useState([]);
    const [newReferent, setNewReferent] = useState(false);
    let hasPrincipal = user.referents.filter(r => r.isMainRepresentative === true).length > 0;

    useEffect(() => {
        if (hasFooter === true) {

            let hasOther = user.referents.filter(r => r.isMainRepresentative === false).length > 0;
            if (user.referents.length > 0 && monReferentRequirements.principal === false) {
                setMonReferentRequirements({ ...monReferentRequirements, principal: hasPrincipal, other: hasOther });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user.referents.length]);


    function formNextStep(event) {
        event.preventDefault();
        const parsedQueryString = queryString.parse(window.location.search);
        if(parsedQueryString.state !== ""){
            dispatch(updateOnBoardingStep(3)).then(() => history.push("/auth/signup/step4" + (window.location.search !== '' ? window.location.search : '')))
            return;
        }

        if (!R.isNil(user.user) && !R.isNil(user.referents) && user.referents.length > 0) {
            dispatch(updateOnBoardingStep(3));
            history.push("/auth/signup/step4"  + (window.location.search !== '' ? window.location.search : ''));
        }
    }


    return (
        <article className={"view-calc mt-3 mb-auto mt-lg-n3 mb-lg-0 pt-3"}>
            <div className="container-fluid">
                <header className="rounded-bottom-left-sm rounded-top-right-sm alert alert-primary text-center sticky-top">
                    <h1 className="text-primary font-weight-bolder mt-2 mb-2">Mon référent</h1>
                    <p className="h3 text-dark lh-solid mb-0 text-truncate">C'est le proche de confiance qui accédera à mon dossier uniquement en cas d'événement de vie (décès)</p>
                </header>
            </div>
            <div className="auto-view pb-3 pb-lg-0 mb-lg-0">
                <div className="container-fluid">
                    {(router.location.pathname.toLowerCase().indexOf("/anticipa/referent") === 0) || (router.location.pathname.toLowerCase().indexOf("/auth/signup/step3") === 0) ?
                        <div className="card rounded mb-xs bg-white shadow-xs alert-bagde border-none o-80 o-100--hover">
                            <div className="card-body px-xs py-2 my-auto o-80" role="button" data-toggle="modal" data-target="#messageEdit">
                                <div className="row gx-2">
                                    <div className="col-auto flex-column">
                                        <img className="img-fluid h-5 m-auto block t-border" src={messageRef} alt="message Ref" />
                                    </div>
                                    <div className="col-auto flex-column">
                                        <h3 className="fs-3 my-auto lh-copy">
                                            {
                                                R.isEmpty(user.message) ?
                                                    "Écrivez un message à votre/vos Référent(s)"
                                                    :
                                                    "Modifier le message à votre/vos Référent(s)"
                                            }
                                        </h3>
                                    </div>
                                    <div className="col-auto flex-column ml-auto">
                                        <button className="btn btn-icon btn-action w-5 px-2 my-auto"><i className="eva eva-edit-2-outline align-middle fs-lead lh-solid m-auto"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : ''
                    }
                    <div className="grid grid-md-base grid-xl-wide">
                        {(user.referents.length > 0) ?
                            user.referents.map((r, index) => {
                                if (isEditing.includes(r.id)) {
                                    return <EditReferent setNewReferent={setNewReferent} key={index} refIndex={index} data={r} isEditing={isEditing} setIsEditing={setIsEditing} />;
                                }
                                else {
                                    return <ColapsedReferent key={index} data={r} isEditing={isEditing} setIsEditing={setIsEditing} hideResendInvitation={true} />;
                                }
                            })
                            :
                                user.user.hasHrDocuments ?
                                    ''
                                :
                                    <div className="card card-body">
                                        <EditReferent setNewReferent={setNewReferent} isNew={true} data={{ isMainRepresentative: true, tmpRef: 'main' }} refIndex={'main_0'} />
                                    </div>
                        }
                        <div className="card card-body">
                            <button className={`btn btn-alert-info font-weight-bolder mb-3 py-2`} type="button" onClick={() => { setNewReferent(true); }}>
                                <i className="eva lh-copy eva-person-add-outline mr-2 my-auto h3 lh-solid d-inline-block align-middle "></i> Ajouter un autre référent
                            </button>

                            <p className="h5 o-80 font-weight-bold lh-copy mb-3 pb-2 ls-n1">IL EST FORTEMENT CONSEILLÉ DE RENSEIGNER AU MOINS 2 RÉFÉRENTS AFIN D’OPTIMISER VOTRE SERVICE.</p>
                            <p className="h5 o-50 lh-copy">Chaque référent sera averti par mail et message annuellement de votre démarche. <br />Au même titre, il n’aura pas accès aux informations de votre dossier (comptes bancaires, contrats d’assurance...).</p>

                            {
                                newReferent === true ?
                                    <React.Fragment>
                                        <hr className="my-3" />
                                        <EditReferent isNew={true} data={{ tmpRef: `other_${(user.referents.length + 1)}` }} refIndex={`other_${(user.referents.length + 1)}`} setNewReferent={setNewReferent} />
                                    </React.Fragment>
                                    : ''
                            }
                        </div>
                    </div>
                </div>
                {
                    hasFooter === true ?
                        <div className="container-fluid">
                            <footer className="flex-md-row align-items-center mt-auto mb-sm text-lg-right w-100">
                                <Link to={"/auth/signup/step2" + (window.location.search !== '' ? window.location.search : '')} className="btn btn-faded px-md-gutter mr-3 ml-auto">Retour</Link>
                                <button className="btn btn-info loading-btn px-md-gutter px-4" onClick={(event) => {
                                    formNextStep(event);
                                }}>Passer à l'étape suivante
                                    <div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
                                </button>
                                {/* <Link to="/auth/signup/step4" className="btn btn-info px-md-gutter px-4">Passer à l'étape suivante</Link> */}
                                <h6 className="my-3 my-md-0 mr-auto order-lg-first fs-3 o-60">* champs obligatoires</h6>
                            </footer>
                        </div>
                        : ''
                }
            </div>
        </article>
    );
};